import { useState, useCallback } from 'react';
import { useSnackbar } from '../contexts/SnackbarContext';
import { LogOut, Loader2 } from 'lucide-react';
import { useSignOut } from '../hooks/useSignOut';

const CustomUserButton = ({ chatClient }) => {
  const { addSnackbar } = useSnackbar();
  const signout = useSignOut();
  const [loading, setLoading] = useState(false);

  const handleSignOut = useCallback(async () => {
    setLoading(true);
    try {
      if (chatClient) await chatClient.disconnectUser();
      sessionStorage.setItem('signingOut', 'true');
      await signout();
    } catch (error) {
      addSnackbar('Error signing out. Try again.', 'error');
      setLoading(false);
    }
  }, [chatClient, signout, addSnackbar]);

  return (
    <button
      onClick={handleSignOut}
      disabled={loading}
      className="group relative flex items-center justify-center gap-2 px-5 py-2.5 rounded-full transition-all duration-300 active:scale-95 disabled:opacity-50"
      style={{
        background: 'rgba(255, 59, 48, 0.05)', // iOS Red at 5% opacity
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        border: '0.5px solid rgba(255, 59, 48, 0.3)', // Red glass border
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2), inset 0 1px 1px rgba(255, 255, 255, 0.05)',
      }}
    >
      {/* Red Pulse Inner Glow */}
      <div className="absolute inset-0 rounded-full bg-red-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <span className="relative z-10 text-[13px] font-bold tracking-tight text-red-400 group-hover:text-red-300 transition-colors">
        {loading ? 'Disconnecting' : 'Sign Out'}
      </span>

      {loading ? (
        <Loader2 className="relative z-10 w-3.5 h-3.5 animate-spin text-red-400" />
      ) : (
        <LogOut className="relative z-10 w-3.5 h-3.5 text-red-400 group-hover:translate-x-0.5 transition-transform" />
      )}
    </button>
  );
};

export default CustomUserButton;
